import React, { useState, useEffect } from 'react';
import { PorteroLayout } from '../../components/portero/PorteroLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Skeleton } from '../../components/ui/skeleton';
import { getLog } from '../../lib/porteroApi';
import { toast } from 'sonner';
import { List, CheckCircle2, XCircle } from 'lucide-react';

export default function PorteroLogPage() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const d = await getLog(100);
        setLogs(d.logs || []);
      } catch (e) { toast.error(e.message); }
      setLoading(false);
    };
    load();
  }, []);

  return (
    <PorteroLayout>
      <div className="p-4 sm:p-6 space-y-4" data-testid="portero-log">
        <h1 className="text-xl font-bold text-white flex items-center gap-2">
          <List className="h-5 w-5" /> Registro de Actividad
        </h1>

        <Card className="bg-zinc-900 border-zinc-800">
          <CardContent className="p-0">
            {loading ? (
              <div className="p-4"><Skeleton className="h-40 bg-zinc-800" /></div>
            ) : logs.length === 0 ? (
              <p className="text-sm text-zinc-600 text-center py-8">Sin actividad registrada</p>
            ) : (
              <div className="divide-y divide-zinc-800">
                {logs.map(log => {
                  const hasError = log.resultado?.errors?.length > 0 && log.resultado.errors[0]?.includes('Sin conexión');
                  return (
                    <div key={log.id} className="p-3 sm:p-4 flex items-start gap-3">
                      {hasError ? (
                        <XCircle className="h-4 w-4 text-amber-500 mt-0.5 shrink-0" />
                      ) : (
                        <CheckCircle2 className="h-4 w-4 text-emerald-500 mt-0.5 shrink-0" />
                      )}
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="text-sm font-medium text-white">{log.boton_nombre || 'Comando'}</span>
                          <Badge variant="outline" className="text-[10px] border-zinc-700 text-zinc-500 font-mono">
                            {log.comando}
                          </Badge>
                        </div>
                        <div className="text-xs text-zinc-500 mt-1">
                          {log.usuario_nombre || log.usuario_email} &middot; Device {log.device_id}
                          {hasError && <span className="text-amber-400 ml-2">Sin conexión GPRS</span>}
                        </div>
                      </div>
                      <span className="text-[10px] text-zinc-600 shrink-0">
                        {new Date(log.timestamp).toLocaleString('es-CL', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </PorteroLayout>
  );
}
